import styled from "styled-components";
import { ReactComponent as IconLogout } from "../Images/icon_logout_red.svg";
import { ReactComponent as IconProfile } from "../Images/icon_profile.svg";
import { ReactComponent as IconSetting } from "../Images/icon_setting.svg";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import { useGoToAddr } from "../Utils/navigationUtils";
import {
  clearDashboardSession,
  getAuthSession,
  getCompanyProfile,
} from "../Utils/sessionUtils.js";

const ProfileModal = ({ handleClick_setting }) => {
  const goToAddr = useGoToAddr();
  const { companyName } = getCompanyProfile();

  const handleLogout = async () => {
    try {
      const { accessToken } = getAuthSession();
      const headers = {
        "Content-Type": "application/json",
      };

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/dashboard/auth/logOut`,
        {
          method: "POST",
          headers,
          credentials: "include",
          body: JSON.stringify({}),
        }
      );
      const responseData = await response.json();

      if (responseData.code === 200) {
        clearDashboardSession();
        window.location.reload("/login");
        // navigate("/login");
      }
    } catch (error) {
      console.error("로그아웃 중 에러 발생:", error);
      throw error;
    }
  };

  return (
    <Box>
      <div style={{ display: "flex" }}>
        <IconProfile />
        <div style={{ width: "218px", marginLeft: "8px" }}>
          <p
            style={{
              fontFamily: "notoSans-medium",
              color: "#222222",
            }}
          >
            {companyName}
          </p>
          <div style={{ display: "flex" }} onClick={() => goToAddr("company")}>
            <p style={{ color: "#1167ed", fontSize: "14px" }}>기업정보 관리</p>
            <RightBracket stroke="#1167ed" />
          </div>
        </div>
      </div>

      <div
        className="button"
        style={{ marginTop: "14px" }}
        onClick={handleClick_setting}
      >
        <div style={{ width: "14px" }} />
        <IconSetting />
        <p style={{ marginLeft: "8px", color: "#8E96A0" }}>계정 및 환경설정</p>
      </div>

      <div
        className="button"
        style={{ marginTop: "4px" }}
        onClick={handleLogout}
      >
        <div style={{ width: "14px" }} />
        <IconLogout />
        <p style={{ marginLeft: "8px", color: "#f25c5c" }}>로그아웃</p>
      </div>
    </Box>
  );
};

const Box = styled.div`
  width: auto;
  height: auto;
  border-radius: 10px;
  padding: 12px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 #e6e6e6;
  z-index: 1;

  .button {
    width: 276px;
    height: 40px;
    border-radius: 8px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    > p {
      font-family: "notoSans-medium";
      font-size: 16px;
    }
    cursor: pointer;
    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

export default ProfileModal;
